import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.dashboard');
import { OnDestroy, OnInit } from '@angular/core';
import Chart from 'chart.js/auto';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-admin-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.dashboard/view.scss */
:host {
  display: block;
  width: 100%;
}

.dashboard-page {
  width: min(100%, 1280px);
  margin: 0 auto;
  padding: 24px 28px 40px;
}

.dashboard-header {
  display: flex;
  min-height: 36px;
  align-items: center;
  margin-bottom: 18px;
  padding: 2px 2px 4px;
}

.dashboard-header h1 {
  color: #111827;
  font-size: 24px;
  font-weight: 800;
  letter-spacing: -0.03em;
}

.dashboard-kpis {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}

.dashboard-kpi {
  position: relative;
  overflow: hidden;
  min-width: 0;
  padding: 17px 18px 16px;
  border: 1px solid var(--admin-border, #dce2ea);
  border-radius: 12px;
  background: var(--admin-surface, #fff);
  box-shadow: var(--admin-shadow-card, 0 1px 2px rgba(15, 23, 42, 0.04));
}

.dashboard-kpi::before {
  position: absolute;
  top: -22px;
  right: -18px;
  width: 64px;
  height: 64px;
  border-radius: 999px;
  background: var(--kpi-accent, var(--admin-primary, #4f46e5));
  content: "";
  opacity: 0.09;
}

.dashboard-kpi--total {
  --kpi-accent: var(--admin-primary, #4f46e5);
}

.dashboard-kpi--progress {
  --kpi-accent: var(--admin-warning, #b45309);
}

.dashboard-kpi--completed {
  --kpi-accent: var(--admin-success, #047857);
}

.dashboard-kpi--attention {
  --kpi-accent: var(--admin-danger, #be123c);
}

.dashboard-kpi__label {
  color: var(--admin-text-muted, #64748b);
  font-size: 12px;
  font-weight: 600;
}

.dashboard-kpi__value {
  margin-top: 8px;
  color: var(--kpi-accent, var(--admin-text-strong, #111827));
  font-size: 26px;
  line-height: 1;
  font-weight: 750;
  letter-spacing: -0.04em;
}

.dashboard-panel {
  min-width: 0;
  padding: 18px;
  border: 1px solid var(--admin-border, #dce2ea);
  border-radius: 12px;
  background: var(--admin-surface, #fff);
  box-shadow: var(--admin-shadow-card, 0 1px 2px rgba(15, 23, 42, 0.04));
}

.dashboard-trend {
  margin-bottom: 14px;
}

.dashboard-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.dashboard-panel__head {
  display: flex;
  min-height: 30px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.dashboard-panel__head h2 {
  display: flex;
  align-items: center;
  color: var(--admin-text-strong, #111827);
  font-size: 15px;
  font-weight: 700;
}

.dashboard-panel__head h2::before {
  width: 7px;
  height: 7px;
  margin-right: 8px;
  border-radius: 999px;
  background: var(--panel-accent, var(--admin-primary, #4f46e5));
  content: "";
}

.dashboard-trend {
  --panel-accent: var(--admin-primary, #4f46e5);
}

.dashboard-panel--recent {
  --panel-accent: var(--admin-success, #047857);
}

.dashboard-panel--pending {
  --panel-accent: var(--admin-warning, #b45309);
}

.dashboard-panel__count {
  color: var(--admin-text-muted, #64748b);
  font-size: 12px;
  font-weight: 600;
}

.dashboard-chart-shell {
  margin-top: 10px;
  padding-top: 8px;
  border-top: 1px solid var(--admin-border-soft, #edf1f5);
}

.dashboard-chart {
  height: 180px;
}

.dashboard-table-wrap {
  overflow-x: auto;
  margin-top: 8px;
}

.dashboard-table {
  width: 100%;
  min-width: 500px;
  border-collapse: collapse;
  color: var(--admin-text-muted, #64748b);
  font-size: 12px;
}

.dashboard-table th {
  padding: 9px 8px;
  border-bottom: 1px solid var(--admin-border, #dce2ea);
  background: var(--admin-surface-subtle, #f8fafc);
  color: var(--admin-text, #334155);
  font-weight: 600;
  text-align: left;
}

.dashboard-table td {
  padding: 10px 8px;
  border-bottom: 1px solid var(--admin-border-soft, #edf1f5);
}

.dashboard-table tbody tr:last-child td {
  border-bottom: 0;
}

.dashboard-table tbody tr:hover {
  background: var(--admin-surface-subtle, #f8fafc);
}

.dashboard-table .font-medium {
  color: var(--admin-text-strong, #111827);
}

.dashboard-link {
  color: var(--admin-primary, #4f46e5);
  font-size: 12px;
  font-weight: 700;
}

.dashboard-empty {
  padding: 24px 0;
  color: var(--admin-text-faint, #94a3b8);
  font-size: 12px;
  text-align: center;
}

.dashboard-link:hover {
  text-decoration: underline;
}

@media (max-width: 1023px) {
  .dashboard-grid {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 767px) {
  .dashboard-page {
    padding: 16px 16px 32px;
  }
  .dashboard-kpis {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .dashboard-kpi {
    padding: 14px;
  }
  .dashboard-kpi__value {
    font-size: 23px;
  }
}`],
})
export class PageAdminDashboardComponent implements OnInit, OnDestroy {
    public stats: any = { total: 0, pending: 0, in_progress: 0, completed: 0, expired: 0 };
    public recent: any[] = [];
    public pending: any[] = [];
    public daily: any[] = [];
    private trendChart: Chart | null = null;
    private readonly trendCanvasId = 'dashboard-trend-chart';

    constructor(@Inject( Service) public service: Service) { }

    private payload(data: any): any {
        if (data && data.data !== undefined) {
            return data.data;
        }
        return data || {};
    }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public ngOnDestroy() {
        this.destroyTrendChart();
    }

    public async load() {
        const { code, data } = await wiz.call("overview");
        if (code === 200 && data) {
            const payload = this.payload(data);
            this.stats = payload.stats || this.stats;
            this.recent = payload.recent || [];
            this.pending = payload.pending || [];
            this.daily = payload.daily || [];
        }
        await this.service.render();
        this.renderTrendChart();
    }

    private destroyTrendChart() {
        if (this.trendChart) {
            this.trendChart.destroy();
            this.trendChart = null;
        }
    }

    private renderTrendChart() {
        this.destroyTrendChart();
        if (!this.daily || this.daily.length === 0) return;

        const canvas = document.getElementById(this.trendCanvasId) as HTMLCanvasElement | null;
        if (!canvas) return;

        const labels = this.daily.map((item: any) => this.shortDate(item.date));
        const data = this.daily.map((item: any) => Number(item.count || 0));
        const max = Math.max(...data, 1);

        this.trendChart = new Chart(canvas, {
            type: 'line',
            data: {
                labels,
                datasets: [{
                    label: '제출 건수',
                    data,
                    borderColor: '#4f46e5',
                    backgroundColor: 'rgba(99, 102, 241, 0.12)',
                    fill: true,
                    pointRadius: 4,
                    pointHoverRadius: 7,
                    pointHitRadius: 16,
                    pointBackgroundColor: '#4338ca',
                    pointBorderColor: '#ffffff',
                    pointBorderWidth: 2,
                    pointHoverBorderWidth: 3,
                    tension: 0.35,
                }],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                animation: false,
                interaction: {
                    mode: 'index',
                    intersect: false,
                },
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        displayColors: false,
                        callbacks: {
                            title: (items) => items[0]?.label || '',
                            label: (context) => `제출 ${context.formattedValue}건`,
                        },
                    },
                },
                scales: {
                    x: {
                        grid: { display: false, drawBorder: false },
                        border: { display: false },
                        ticks: {
                            color: '#94a3b8',
                            maxRotation: 0,
                            autoSkip: true,
                            maxTicksLimit: 7,
                            font: { size: 10 },
                        },
                    },
                    y: {
                        beginAtZero: true,
                        suggestedMax: max,
                        border: { display: false },
                        grid: {
                            color: 'rgba(148, 163, 184, 0.18)',
                            drawBorder: false,
                        },
                        ticks: {
                            stepSize: max > 1 ? undefined : 1,
                            color: '#94a3b8',
                            font: { size: 10 },
                        },
                    },
                },
            },
        });
    }

    public statusBadge(status: string): string {
        const map: any = {
            'pending':     'bg-slate-100 text-slate-700',
            'in_progress': 'bg-amber-100 text-amber-700',
            'completed':   'bg-emerald-100 text-emerald-700',
            'expired':     'bg-rose-100 text-rose-700'
        };
        return map[status] || 'bg-slate-100 text-slate-700';
    }

    public statusLabel(status: string): string {
        const map: any = {
            'pending':     '미응답',
            'in_progress': '진행중',
            'completed':   '완료',
            'expired':     '만료'
        };
        return map[status] || status;
    }

    public copyLink(token: string) {
        const url = location.origin + '/s/' + token;
        navigator.clipboard.writeText(url).then(() => alert('URL이 복사되었습니다.\n' + url));
    }

    public dailyTotal(): number {
        return (this.daily || []).reduce((sum: number, item: any) => sum + Number(item?.count || 0), 0);
    }

    public formatDate(value: string): string {
        if (!value) return '-';
        return String(value).slice(0, 10);
    }

    public formatDateTime(value: string): string {
        if (!value) return '-';
        return String(value).slice(0, 16);
    }

    public shortDate(value: string): string {
        if (!value) return '';
        return value.slice(5).replace('-', '/');
    }
}

export default PageAdminDashboardComponent;